/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StationOrLocation,
    StationOrLocationFromJSON,
    StationOrLocationFromJSONTyped,
    StationOrLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface StationOrLocationListBusinessDataResponse
 */
export interface StationOrLocationListBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof StationOrLocationListBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<StationOrLocation>}
     * @memberof StationOrLocationListBusinessDataResponse
     */
    businessData?: Array<StationOrLocation> | null;
    /**
     * 
     * @type {number}
     * @memberof StationOrLocationListBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof StationOrLocationListBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof StationOrLocationListBusinessDataResponse
     */
    totalRecords?: number;
}

export function StationOrLocationListBusinessDataResponseFromJSON(json: any): StationOrLocationListBusinessDataResponse {
    return StationOrLocationListBusinessDataResponseFromJSONTyped(json, false);
}

export function StationOrLocationListBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationOrLocationListBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(StationOrLocationFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function StationOrLocationListBusinessDataResponseToJSON(value?: StationOrLocationListBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(StationOrLocationToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


